import { observer } from 'mobx-react-lite';
import { Suspense, SyntheticEvent, useEffect, useState } from 'react';
import {
  Card,
  Header,
  Grid,
  Icon,
  Segment,
  Form,
  Input,
  Button,
} from 'semantic-ui-react';
import { useStore } from '../../../app/stores/store';
import WorkflowTemplates from './WorkflowTemplates';
import { v4 as uuid } from 'uuid';
import { AssetType, elementTypes } from '../../../app/models/template';
import {
  cardcolor,
  errorEmptyText,
  errorMessageText,
  selectionEmptyErrorMsg,
} from '../../../app/common/form/errorMessageText';
import sendRespectiveEmail from '../../../app/models/EmailNew';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import DeleteModal from '../../../library/deleteModal';

const cardStyleLevel4 = {
  display: 'inline-block',
  padding: '10px',
  height: '79vh',
  width: '200pt',
  marginLeft: '2px',
  marginTop: '30px',
  color: 'black',
  cursor: 'pointer',
  boxShadow: '5px 5px 10px lightgray',
  alignItems: 'center',
};

function WorkflowElementTypes() {
  const {
    TemplateStore,
    workflowConfigurationStore,
    userStore,
    RolesAndPermissionsIDStore,
    commonStore,
  } = useStore();
  const {
    assetTypeRegistry,
    loadAssetTypes,
    loadElementTypeById,
    createElementUnderAssetType,
    loadingInitialET,
    selectedAssetType,
    selectedElementTypes,
    editElementType,
    deleteElementType,
    cloneElementTypes,
  } = TemplateStore;
  const [errorType, setErrorType] = useState<string>('');
  const [getnewkey, setgetnewkey] = useState<number | null>();
  const [newElementTypes, setNewElementTypes] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteOption, setDeleteOption] = useState<elementTypes>({
    id: '',
    elementTypeIndex: 0,
    elementName: '',
    isActive: false,
    isDeleted: false,
    templateTypes: [],
    metadata: [],
  });

  useEffect(() => {
    if (assetTypeRegistry.size <= 1) {
      setErrorType('');
      loadAssetTypes();
    }
  }, [assetTypeRegistry.size, loadAssetTypes]);

  /////////////////this function to handle when Enter Key is pressed
  const handleKeyPress = (e: any) => {
    if (
      e.key === 'Enter' &&
      workflowConfigurationStore.WorkflowConfiguration
        .editClickedElementType === false
    ) {
      handleAddElementTypes();
    }
    if (
      e.key === 'Enter' &&
      workflowConfigurationStore.WorkflowConfiguration
        .editClickedElementType === true
    ) {
      handleSaveEdited('edit');
    }
  };
  const handleElementTypes = (id: string) => {
    if (
      workflowConfigurationStore.WorkflowConfiguration.disableClick === false
    ) {
      setErrorType('');
      loadElementTypeById(id); // asset type load child inside
      workflowConfigurationStore.setShowTemplateCard(true); // set elementtype  true
      workflowConfigurationStore.setShowElementTypesName(id); //set element types name
      workflowConfigurationStore.setShowTaskCard(false); // set  task, subtask, element   false
      workflowConfigurationStore.setShowSubTaskCard(false); // set  task, subtask, element   false
      workflowConfigurationStore.setShowElementCard(false); // set  task, subtask, element   false
    }
    //ResetEdit
    workflowConfigurationStore.resetEditClickedButtonExceptElementType();
  };
  ///////////////Adds Element Types to API and Front End Schema

  const handleChangeName = (e: SyntheticEvent, data: any) => {
    setNewElementTypes(data.value);
    const NameCheck = selectedAssetType?.elementTypes.some(function (el) {
      function ciEquals(a: string, b: string) {
        return typeof a === 'string' && typeof b === 'string'
          ? a.trim().localeCompare(b.trim(), undefined, {
              sensitivity: 'accent',
            }) === 0
          : a.trim() === b.trim();
      }
      return ciEquals(el.elementName, data.value);
    });
    setErrorType(NameCheck ? 'SameName' : ''); //check name exists
  };
  ///////////////Adds Element Types to API and Front End Schema
  const handleAddElementTypes = () => {
    if (selectedAssetType !== undefined && newElementTypes.length !== 0) {
      const elementTypes = selectedAssetType?.elementTypes;
      const ID = uuid();
      const newArr = {
        id: ID,
        elementTypeIndex:
          elementTypes.length === 0 ? 0 : elementTypes.length + 1,
        elementName: newElementTypes,
        templateTypes: [],
        metadata: [],
        isActive: true,
        isDeleted: false,
      };
      //For roles and permissions
      const newRoleArr = {
        id: uuid(),
        itemId: ID,
        rolesId:
          userStore.user?.roleId !== undefined ? userStore.user?.roleId : '',
      };
      // for backend
      const selectedAssetTypeArr = {
        ...selectedAssetType,
        elementTypes: [newArr],
      };
      // for front end schema
      elementTypes.push(newArr);
      const AllvaluefrontEndData = {
        ...selectedAssetType,
        elementTypes: elementTypes,
      };
      createElementUnderAssetType(selectedAssetTypeArr, AllvaluefrontEndData); //create
      sendRespectiveEmail(
        'created',
        newArr.elementName,
        'Created Element Type',
        '',
      ); //email Function
      RolesAndPermissionsIDStore.createRoleID(newRoleArr); //roles and permissions
    } else {
      setErrorType('EmptyName');
    }
    setNewElementTypes('');
  };
  ////////////// Clone data and Update Id for each Child
  const handleClone = () => {
    let flag = 0;
    selectedAssetType?.elementTypes?.forEach((data) => {
      if (data.id === selectedElementTypes?.id) {
        flag = 1;
      }
    });
    if (
      selectedElementTypes &&
      selectedAssetType !== undefined &&
      newElementTypes.length > 0 &&
      flag
    ) {
      cloneElementTypes({
        id: selectedAssetType.id,
        cloned_from: selectedElementTypes.id,
        cloned_as: newElementTypes,
      });

      sendRespectiveEmail('cloned', newElementTypes, 'Cloned Element Type', ''); //email Function
    } else if (!flag) {
      setErrorType('selectionEmpty');
    } else if (newElementTypes.length === 0) {
      setErrorType('EmptyName');
    }
    setNewElementTypes('');
  };
  ////////////// happens When Edit is Clicked
  const handleEdit = (elementType: elementTypes) => {
    setErrorType('');
    loadElementTypeById(elementType.id);
    setNewElementTypes(elementType.elementName);
    workflowConfigurationStore.setEditClickedElementType(true);
  };
  //////////////Function to handle Save Edited
  const handleSaveEdited = (name: string) => {
    if (
      selectedElementTypes &&
      selectedAssetType !== undefined &&
      name === 'edit' &&
      newElementTypes.length !== 0
    ) {
      const newArr = {
        ...selectedElementTypes,
        elementName: newElementTypes,
      };
      editElementType(newArr);
      sendRespectiveEmail(
        'edited',
        newArr.elementName,
        'Edited Element Type',
        '',
      ); //email Function
      //to update dom
      const data = selectedAssetType?.elementTypes;
      const index = data.findIndex((obj) => obj.id === selectedElementTypes.id);
      data[index].elementName = newElementTypes;
    }
    setNewElementTypes('');
    workflowConfigurationStore.setEditClickedElementType(false);
  };
  /////////////////////Delete
  const handleDelete = (elementType: elementTypes) => {
    if (selectedAssetType !== undefined) {
      setErrorType('');
      setDeleteOption(elementType);
      setIsModalOpen(true);
    }
  };
  const deleteConfirmed = () => {
    const ElementTypeJSXs = selectedAssetType?.elementTypes;
    const elementTypeArr = {
      ...deleteOption,
      isDeleted: true,
    };
    //  const frontEndArr to show Delete
    const filterData =
      ElementTypeJSXs !== undefined
        ? ElementTypeJSXs.filter((item) => item.id !== deleteOption.id)
        : [];
    const AllvaluefrontEndData = {
      ...selectedAssetType,
      elementTypes: filterData,
    };

    deleteElementType(elementTypeArr, AllvaluefrontEndData as AssetType);
    sendRespectiveEmail(
      'deleted',
      elementTypeArr.elementName,
      'Deleted Element Type',
      '',
    ); //email Function
    setIsModalOpen(false);
  };

  const ElementTypeJSX = (
    <Card className="workflow-config-assettypes">
      {selectedAssetType?.elementTypes.map((elementTypes, index) => (
        <>
          <Card.Content
            key={index}
            onMouseEnter={() => setgetnewkey(index)}
            onMouseLeave={() => setgetnewkey(null)}
            style={
              elementTypes.id ===
              workflowConfigurationStore.WorkflowConfiguration
                .showElementTypesName
                ? cardcolor
                : null
            }
            onClick={() => handleElementTypes(elementTypes.id)}
          >
            <Grid className="hoverColor" columns={3}>
              <Grid.Row>
                <Grid.Column width={12}>{elementTypes.elementName}</Grid.Column>
                <Grid.Column
                  width={1}
                  onMouseEnter={() =>
                    workflowConfigurationStore.setDisableClick(true)
                  }
                  onMouseLeave={() =>
                    workflowConfigurationStore.setDisableClick(false)
                  }
                >
                  {getnewkey === index ? (
                    <Icon
                      style={{ fontSize: '13px' }}
                      name="pencil"
                      color="grey"
                      size="small"
                      onClick={() => handleEdit(elementTypes)}
                    />
                  ) : null}
                </Grid.Column>
                <Grid.Column
                  width={1}
                  onMouseEnter={() =>
                    workflowConfigurationStore.setDisableClick(true)
                  }
                  onMouseLeave={() =>
                    workflowConfigurationStore.setDisableClick(false)
                  }
                >
                  {getnewkey === index ? (
                    <Icon
                      style={{ fontSize: '13px' }}
                      name="trash"
                      color="grey"
                      size="small"
                      onClick={() => handleDelete(elementTypes)}
                    />
                  ) : null}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Card.Content>
        </>
      ))}
    </Card>
  );

  return (
    <div>
      {isModalOpen && (
        <Suspense fallback={<></>}>
          <DeleteModal
            isModalOpen={isModalOpen}
            closeHandler={() => {
              setIsModalOpen(false);
            }}
            deleteHandler={deleteConfirmed}
            header={'Delete'}
            text={
              'Are you sure you want to delete this? Deleting it will also remove all related data.'
            }
          />
        </Suspense>
      )}
      <Grid>
        <Card style={cardStyleLevel4}>
          <>
            <Header
              style={{ marginLeft: '20px' }}
              size="huge"
              as="h1"
              content="Element Types"
              sub
              color="grey"
            />
            {!selectedAssetType || loadingInitialET ? (
              <LoadingComponent />
            ) : (
              ElementTypeJSX
            )}
          </>
          <Segment className="workflow-bottom-card">
            <Form>
              <Form.Group widths="equal">
                <Form.Field
                  id="form-input-control-error-email"
                  className=" workflow-input"
                  error={
                    errorType === 'SameName'
                      ? errorMessageText
                      : errorType === 'EmptyName'
                        ? errorEmptyText
                        : errorType === 'selectionEmpty'
                          ? selectionEmptyErrorMsg
                          : null
                  }
                  control={Input}
                  value={newElementTypes}
                  placeholder="Create New"
                  onChange={handleChangeName}
                  onKeyDown={handleKeyPress}
                />
              </Form.Group>
            </Form>
            {workflowConfigurationStore.WorkflowConfiguration
              .editClickedElementType === false ? (
              <div className="workflow-input-div">
                {commonStore.filterModeTwo?.includes('SWB08') ? (
                  <></>
                ) : (
                  <Button
                    primary
                    onClick={handleClone}
                    className="workflow-input-button"
                    disabled={
                      commonStore.filterModeZero?.includes('SWB08') ||
                      errorType !== ''
                    }
                  >
                    {' '}
                    Clone{' '}
                  </Button>
                )}

                {/* <Button primary onClick={handleClone} className="workflow-input-button" disabled={!dashboardStore.dashboard.selectedUserRoleId.includes("SWB08")?true:false || errorType==='SameName'||errorType==='EmptyName'?true:false}> Clone </Button> */}

                {commonStore.filterModeTwo?.includes('SWB06') ? (
                  <></>
                ) : (
                  <Button
                    color="green"
                    floated="right"
                    onClick={handleAddElementTypes}
                    className="workflow-input-button"
                    disabled={
                      commonStore.filterModeZero?.includes('SWB06') ||
                      errorType !== ''
                    }
                  >
                    Add New
                  </Button>
                )}

                {/* <Button color="green" floated='right' onClick={handleAddElementTypes}  className="workflow-input-button" disabled={!dashboardStore.dashboard.selectedUserRoleId.includes("SWB06")?true:false || errorType==='SameName'||errorType==='EmptyName'?true:false}>Add New</Button> */}
              </div>
            ) : (
              <div className="workflow-input-div">
                <Button
                  secondary
                  className="workflow-input-button"
                  onClick={() => handleSaveEdited('cancel')}
                >
                  {' '}
                  Cancel
                </Button>
                <Button
                  primary
                  floated="right"
                  onClick={() => handleSaveEdited('edit')}
                  className="workflow-input-button"
                  disabled={
                    errorType === 'SameName' || errorType === 'EmptyName'
                      ? true
                      : false
                  }
                >
                  {' '}
                  Save
                </Button>
              </div>
            )}
          </Segment>
        </Card>
        {workflowConfigurationStore.WorkflowConfiguration
          .showElementTypesCard &&
        workflowConfigurationStore.WorkflowConfiguration.showTemplateCard ? (
          <WorkflowTemplates />
        ) : null}
      </Grid>
    </div>
  );
}

export default observer(WorkflowElementTypes);
